import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
const setCookie = (variable: string, val: string) => {
  console.log(variable, val);
  const ciphertext = CryptoJS.AES.encrypt(val, "SECRET").toString();
  Cookies.set(variable, ciphertext);
};

const getCookie = (variable: string) => {
  const value = Cookies.get(variable) || "";
  return CryptoJS.AES.decrypt(value, "SECRET").toString(CryptoJS.enc.Utf8);
};

const removeCookie = (variable: string) => {
  Cookies.remove(variable);
};

const cookie = {
  setCookie,
  getCookie,
  removeCookie,
};

export default cookie;
